<template>
  <div class="form-check abc-checkbox abc-checkbox-success">
    <input
      class="form-check-input"
      :id="`checkbox-clients-${ability.id}`"
      type="checkbox"
      v-model="isSelected"
      :disabled="isARoleAbility"
    />
    <label class="form-check-label" :for="`checkbox-clients-${ability.id}`">
      {{ ability.title }}
    </label><!-- /.form-check -->
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    ability: {
      required: true,
      type: Object
    },
    selectedRole: {
      required: true,
      type: Object
    }
  },

  computed: {
    isSelected: {
      get () {
        return this.value.find(selectedAbility => selectedAbility.name === this.ability.name) !== undefined
      },

      set (value) {
        this.updateValue(value)
      }
    },

    isARoleAbility () {
      return this.selectedRole.abilities.find(ability => ability.name === this.ability.name) !== undefined
    }
  },

  methods: {
    updateValue (value) {
      const existing = this.value.find(selectedAbility => selectedAbility.name === this.ability.name) !== undefined

      if (value && existing) {
        return
      }

      const newValue = value ? [this.ability].concat(this.value) : this.value.filter(selectedAbility => selectedAbility.id !== this.ability.id)

      this.$emit('input', newValue)
    }
  }
}
</script>
